import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";
import { useBranding } from "@/contexts/BrandingContext";

/**
 * Brand header used at the top of every public/customer-facing page
 * (login, forgot/reset/change password, accept invite, payment success).
 *
 * Stays consistent with the email + PDF branding: company logo + brand
 * accent bar.
 */
export default function PublicBrandHeader({ subtitle, className = "" }) {
  const { brand_color } = useBranding();
  return (
    <div className={`flex flex-col items-center gap-3 mb-8 ${className}`} data-testid="public-brand-header">
      <Link to="/" className="inline-block">
        <BrandLogo size="xl" />
      </Link>
      <div
        className="h-1 w-48 rounded-full"
        style={{ background: brand_color || "#0F172A" }}
        aria-hidden="true"
      />
      {subtitle && (
        <p className="text-xs text-slate-500 tracking-wide uppercase">{subtitle}</p>
      )}
    </div>
  );
}
